module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO16ComoAdministrarDinero(ant47).eda5dfa.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO16ComoAdministrarDinero(ant47).mp4
// module id = 742
// module chunks = 1